import React from 'react'

export default function FixedFooter() {
    return (
        <React.Fragment>
    <div class="footer_fixed">
    <div class="main_wrap">
        <ul class="action">
            <li class="bank"><p>Bank</p></li>
            <li class="p_l"><p>Betting Profit &amp; Loss</p></li>
            <li class="betting_history"><p>Betting History</p></li>
            <li class="profile"><p>Profile</p></li>
            <li class="status"><p>Change Status</p></li>
        </ul>
    </div>
   </div>
        </React.Fragment>
    )
}
